module.exports = __webpack_public_path__ + "static/img/homePageLogos.a70cc54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePageLogos.png
// module id = Heqz
// module chunks = 1